export default {
  ROOT: 'action-button',
  LABEL: 'action-button-label',
  SHOULD_FILL_CONTAINER: 'action-button-shouldFillContainer',
  DISABLED: 'disabled',
  SELECTED: 'selected',
};
